<div class="m-4 px-6 py-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
    @for (doc of documents; track doc) {
      <app-input-file-light
        [maxFileSizeMB]="50"
        [onlyDownload]="false"
        [label]="doc.DESC_DOCUMENTO"
        [AdditionalValuesFiles]="{
          iD_DOCUMENTOS_COTIZACION: 0,
          iD_CARATULA: doc.ID_CARATULA,
          systemFileName: doc.SYSTEM_FILENAME,
          fileName: doc.USER_FILENAME,
          legacyFileName: doc.USER_FILENAME,
        }"
        [formControlGeneral]="documentsForm.get(`${doc.ID_COTIZACION_DOCUMENTO}`)"
        (getFileService)="getFileLigh($event)"
        (downloadFileService)="downloadFileLigh($event)"
        (emitFile)="autoSaveFileLigh(doc, quotationId, $event)"
      ></app-input-file-light>
      <!-- [disabled]="doc.ID_ATTACH_DOCUMENTO ? false : true" [onlyDownload]="true"  -->
    }
  </div>
  <app-load-general [load]="loadService"></app-load-general>
</div>
